import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { Club } from '../types';
import { Colors, Radii } from '../constants';

interface ClubSelectorProps {
  clubs: Club[];
  selectedClub: string | null;
  onSelectClub: (clubId: string | null) => void;
}

export const ClubSelector: React.FC<ClubSelectorProps> = ({
  clubs,
  selectedClub,
  onSelectClub,
}) => {
  return (
    <View style={styles.container}>
      <Picker
        selectedValue={selectedClub}
        onValueChange={onSelectClub}
        style={styles.picker}
      >
        <Picker.Item label="All My Clubs" value={null} />
        {clubs.map(club => (
          <Picker.Item key={club.id} label={club.name} value={club.id} />
        ))}
      </Picker>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  picker: {
    borderWidth: 1,
    borderColor: Colors.borderLight,
    borderRadius: Radii.control,
  },
});
